import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import {action, computed, observable, reaction, toJS} from 'mobx';
import isEmpty from 'lodash/isEmpty';
import {Creatable} from 'react-select';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormSelectField from '../../../components/FormHelpers/formSelectField';
import {demoStudentName, instruments, keys, lessonCategories, levels} from '../../../constants/constants';
import FormInput from '../../../components/FormHelpers/formField';


@injectIntl
@inject('projectStore')
@observer
class LessonInfoFormAdminSection extends Component {
    @observable instrumentsList = instruments.map((item) => {
        return {
            label: this.props.intl.formatMessage({id: `upload.form.instruments.${item.name}`}),
            value: item.name,
            selected: false
        };
    });
    @observable levelsList = levels.map((item) => {
        return {
            label: this.props.intl.formatMessage({id: `constants.level.${item.name}`}),
            value: item.name,
            selected: false
        };
    });
    @observable lessonCategoriesList = lessonCategories.map((item) => {
        return {
            label: this.props.intl.formatMessage({id: `constants.lessonCategory.${item.name}`}),
            value: item.name,
            selected: false
        };
    });
    @observable keysList = keys.map(item => ({label: item.name, value: item.name, selected: false}));

    componentDidMount() {
        reaction(() => this.props.form, (form) => { this.initForm(form); }, {});
    }

    @action initForm = (form) => {
        if (form.category === '') {
            form.category = this.lessonCategoriesList[0].value;
        }
        if (form.level === '') {
            form.level = this.levelsList[0].value;
        }
        if (form.musicalKey === '') {
            form.musicalKey = this.keysList[0].value;
        }
        if (isEmpty(form.instruments)) {
            form.instruments.push(this.instrumentsList[0].value);
        }
        const categoryIndex = this.lessonCategoriesList.findIndex(obj => obj.value === form.category);
        if (categoryIndex !== -1) {
            this.lessonCategoriesList[categoryIndex].selected = true
        }
        const levelIndex = this.levelsList.findIndex(obj => obj.value === form.level);
        if (levelIndex !== -1) {
            this.levelsList[levelIndex].selected = true
        }
        const keyIndex = this.keysList.findIndex(obj => obj.value === form.musicalKey);
        if (keyIndex !== -1) {
            this.keysList[keyIndex].selected = true
        }
        form.instruments.forEach((instrument) => {
            this.instrumentsList.find(obj => obj.value === (instrument.name || instrument)).selected = true;
        });
    };

    @computed get instrumentsValue() {
        const {form: {instruments: i}, intl: {formatMessage: translate}} = this.props;
        if (isEmpty(i)) {
            return '';
        } else if (i.length === 1) {
            return translate({id: `upload.form.instruments.${i[0].name || i[0]}`});
        }
        return translate({id: 'upload.form.instruments.multiple'});
    }

    @action onChangeCategory = ({value}, index, state) => {
        this.lessonCategoriesList.forEach((obj) => {
            obj.selected = false;
        });
        this.lessonCategoriesList[index].selected = state;
        this.props.form.category = state ? value : '';
        this.props.updateProjectForm('category');
    };

    @action onChangeLevel = ({value}, index, state) => {
        this.levelsList.forEach((obj) => {
            obj.selected = false;
        });
        this.levelsList[index].selected = state;
        this.props.form.level = state ? value : '';
        this.props.updateProjectForm('level');
    };

    @action onChangeKey = ({value}, index, state) => {
        this.keysList.forEach((obj) => {
            obj.selected = false;
        });
        this.keysList[index].selected = state;
        this.props.form.musicalKey = state ? value : '';
        this.props.updateProjectForm('musicalKey');
    };

    @action onChangeInstrument = (e, index, state) => {
        this.instrumentsList[index].selected = state;
        this.props.form.instruments = this.instrumentsList
            .filter(i => i.selected)
            .map(i => i.value);
        this.props.updateProjectForm('instruments');
    };

    @action onChangeKeywords = (name, value) => {
        this.props.form.keywords = value;
        this.props.updateProjectForm('keywords');
    };

    @action onChangeArtistName = (name, value) => {
        this.props.form.artistName = value;
        this.props.updateProjectForm('artistName');
    };

    @action onChangePublishTeachers = () => {
        this.props.form.isPublishTeachers = !this.props.form.isPublishTeachers;
        this.props.updateProjectForm('isPublishTeachers');
    };

    @action onChangeAddDemo = () => {
        this.props.form.includeInDemoStudent = !this.props.form.includeInDemoStudent;
        this.props.updateProjectForm('includeInDemoStudent');
    };

    @action onChangePublishStudents = () => {
        this.props.form.isPublishStudents = !this.props.form.isPublishStudents;
        this.props.updateProjectForm('isPublishStudents');
    };

    @action onChangeLabels = (labels) => {
        this.props.form.labels = labels.map(l => ({value: l.label.replace(/\s+/g, '-').toLowerCase(), label: l.label}));
        this.props.updateProjectForm('labels');
    };

    @action onChangeIsShareable= () => {
        this.props.form.isShareable = !this.props.form.isShareable;
        this.props.updateProjectForm('isShareable');
    }

    render() {
        const {form, projectStore, intl: {formatMessage: translate}} = this.props;
        return (
            <div className="admin-lesson-publish-div">
                <div className="a-form-row">
                    <div className="a-form-col">
                        <FormSelectField
                            options={this.lessonCategoriesList} value={form.category !== '' ? translate({id: `constants.lessonCategory.${form.category}`}) : ''}
                            label={translate({id: 'library.lessons.category'})} onChange={this.onChangeCategory} disableDelete={true}/>
                    </div>
                    <div className="a-form-col">
                        <FormSelectField
                            options={this.levelsList} value={form.level !== '' ? translate({id: `constants.level.${form.level}`}) : ''}
                            label={translate({id: 'library.lessons.level'})} onChange={this.onChangeLevel} disableDelete={true}/>
                    </div>
                </div>
                <div className="a-form-row">
                    <div className="a-form-col">
                        <FormSelectField
                            options={this.instrumentsList}
                            value={this.instrumentsValue}
                            label={translate({id: 'library.lessons.instruments'})}
                            onChange={this.onChangeInstrument}
                            closeOnSelect={false}/>
                    </div>
                    <div className="a-form-col">
                        <FormSelectField
                            options={this.keysList} value={form.musicalKey}
                            label={translate({id: 'library.lessons.key'})} onChange={this.onChangeKey} disableDelete={true}/>
                    </div>
                </div>
                <div className="a-form-row">
                    <div className="a-form-col">
                        <FormInput
                            type="text"
                            name="keywords"
                            placeholder={translate({id: 'library.lessons.keywords'})}
                            value={form.keywords}
                            onChange={this.onChangeKeywords}
                        />
                    </div>
                    <div className="a-form-col">
                        <FormInput
                            type="text"
                            name="artistName"
                            placeholder={translate({id: 'library.lessons.artistName'})}
                            value={form.artistName}
                            onChange={this.onChangeArtistName}
                        />
                    </div>
                </div>
                <div className="a-form-box">
                    <div className="a-form-top">
                        <div className="a-form-label">
                            <FormattedMessage id="library.lessons.labels"/>
                        </div>
                    </div>
                    <Creatable
                        classNamePrefix="form"
                        className="form-select-container"
                        key={toJS(form.labels)} // forces Creatable to rerender if labels change
                        defaultValue={toJS(form.labels)}
                        placeholder=""
                        onChange={this.onChangeLabels}
                        options={projectStore.adminProjectsLabels}
                        isMulti={true}
                        cacheOptions={false}
                    />
                </div>
                <div className="a-form-row">
                    <div className="a-form-col">
                        <FormControl component="fieldset">
                            <FormLabel component="legend"><FormattedMessage id="library.lessons.demoStudent" values={{demoStudentName}}/></FormLabel>
                            <div className="checkboxes-row">
                                <FormControlLabel
                                    value="add-to-demo" label={translate({id: 'library.lessons.addLessonToDemoStudent'}, {name: demoStudentName})}
                                    control={<Checkbox checked={form.includeInDemoStudent} onChange={this.onChangeAddDemo}/>}
                                />
                            </div>
                        </FormControl>
                    </div>
                    <div className="a-form-col">
                        <FormControl component="fieldset">
                            <FormLabel component="legend"><FormattedMessage id="library.lessons.isShareable"/></FormLabel>
                            <div className="checkboxes-row">
                                <FormControlLabel
                                    value="is-shareable-lesson" label={translate({id: 'library.lessons.isShareableDescriptionText'})}
                                    control={<Checkbox checked={form.isShareable} onChange={this.onChangeIsShareable}/>}
                                />
                            </div>
                        </FormControl>
                    </div>
                </div>
                <div className="lesson-publish-div">
                    <FormControl component="fieldset">
                        <FormLabel component="legend"><FormattedMessage id="library.lessons.publishTo"/></FormLabel>
                        <div className="checkboxes-row">
                            <FormControlLabel
                                value="teachers" label={translate({id: 'library.lessons.publishedToTeachersTitle'})}
                                control={<Checkbox checked={form.isPublishTeachers} onChange={this.onChangePublishTeachers}/>}
                            />
                            <FormControlLabel
                                value="students" label={translate({id: 'library.lessons.publishedToStudentsTitle'})}
                                control={<Checkbox checked={form.isPublishStudents} onChange={this.onChangePublishStudents}/>}
                            />
                        </div>
                    </FormControl>
                </div>
            </div>
        );
    }
}

LessonInfoFormAdminSection.propTypes = {
    form: PropTypes.object,
    updateProjectForm: PropTypes.func
};

export default LessonInfoFormAdminSection;
